<div>
    <h6>
        Mappa Sopralluoghi
    </h6>
    <filtro-mappa (resultingSearch)="applySearch($event)"></filtro-mappa>
    <div id="map"></div>
</div>